import { Link } from 'react-router-dom';
import whatsappIcon from '../assets/img/whatsapp_icon.png';

function Footer() {
  return (
    <>
      <div className="container-fluid footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <h4 className="section-title">NexVeda Networks</h4>
              <p>Makers of Netwatch — intelligent network monitoring for DNS, DHCP, and IP Address Management. Product + expert consulting services.</p>
              <div className="banner-buttons">
                <Link to="/about" className="btn-blue">About Us</Link>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="section-title">Product</h4>
              <Link className="btn btn-link" to="/product">Netwatch Overview</Link>
              <Link className="btn btn-link" to="/product#features">Features</Link>
              <Link className="btn btn-link" to="/product#integrations">Integrations</Link>
              <Link className="btn btn-link" to="/">Home</Link>
              <Link className="btn btn-link" to="/about">About Us</Link>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="section-title">Services</h4>
              <Link className="btn btn-link" to="/services#DDI-Product-Consulting">DDI Product Consulting</Link>
              <Link className="btn btn-link" to="/services#Automation-of-Manual-Tasks">Automation of Manual Tasks</Link>
              <Link className="btn btn-link" to="/services#Strategic-Network-Planning">Strategic Network Planning</Link>
              <Link className="btn btn-link" to="/services#Training-and-Support">Training and Support</Link>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="section-title">Contact Us</h4>
              <div className="position-relative mx-auto contact-info-footer" style={{ maxWidth: '400px' }}>
                <a className="btn btn-link" href="mailto:Nsharma@nexvedanetworks.com">
                  <i className="fa-solid fa-envelope"></i> Nsharma@nexvedanetworks.com
                </a>

                {/* WhatsApp hidden — unhide later */}
                {/* <a className="message-us-on-whatsapp" href="https://wa.me/+918825478149" target="_blank" rel="noopener noreferrer">
                  <img src={whatsappIcon} alt="WhatsApp" /> Message us on WhatsApp
                </a> */}
              </div>
              <div className="d-flex pt-2">
                <a className="btn btn-outline-light btn-social" href="#"><i className="fab fa-twitter"></i></a>
                <a className="btn btn-outline-light btn-social" href="#"><i className="fab fa-facebook-f"></i></a>
                <a className="btn btn-outline-light btn-social" href="#"><i className="fab fa-youtube"></i></a>
                <a className="btn btn-outline-light btn-social" href="#"><i className="fab fa-linkedin-in"></i></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-copy-right">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              Copyright &copy; 2024 NexVeda Networks | All Rights Reserved
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
